module.exports = __webpack_public_path__ + "static/media/waic-jijiang-sale.04d6a8c7.png";